import {
  type ContentType,
  CursorMode,
  ShowcaseContentListItemDto,
  SortDirection,
} from '@repo/api/web/models'

/**
 * Общая логика контентной ленты (новости, блог): курсорный листинг с
 * краулябельной пагинацией и фильтром по тегу из query (`?tag=`, точное
 * совпадение — контракт `Filter.Tag` showcase-API). Тег проносится в ссылку
 * следующей страницы (`carryParams`), canonical остаётся консервативным —
 * без query (см. useListingPagination)
 */
export async function useContentFeed(options: {
  type: ContentType
  /** Ключ useCursorListing — уникален на страницу ('news-list', 'blog-list') */
  listKey: string
}) {
  const route = useRoute()
  const { service } = useContent()
  const pagination = useListingPagination({ carryParams: ['tag'] })

  const tag = computed(() => {
    const value = String(route.query.tag ?? '').trim()
    return value || undefined
  })

  const { collection, pending, meta, hasAfter, nextPage } = await useCursorListing<
    any,
    ShowcaseContentListItemDto
  >({
    key: options.listKey,
    fetcher: query => service.list(query),
    transform: data => ShowcaseContentListItemDto.createFromCollection(data ?? []),
    initialQuery: {
      Limit: 12,
      'Filter.Type': options.type,
      'Filter.Tag': tag.value,
      SortField: 'publishAt',
      SortDirection: SortDirection.DESC,
      CursorMode: CursorMode.AFTER,
      ...pagination.cursorQuery.value,
    },
  })

  const nextHref = computed(() => pagination.nextPageHref(meta.value))

  function loadMore() {
    if (hasAfter.value && !pending.value) nextPage()
  }

  return { collection, pending, nextHref, tag, loadMore }
}
